import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';

const DoctorLogs = ({ admissionId, disableEdit }) => {
  const dlConfig = new ApiConfigFactory(
    'admissions/doctor-logs', // serverRoute
    'Doctor Logs', 
    'admission_id', 
    admissionId 
  );

  dlConfig.title = `Notes for Admission: ${admissionId}`;

  dlConfig.path = '/admission-card/doctor-logs';
  dlConfig.defaultSortFieldId = 'log_id';
  dlConfig.allowAdd = !disableEdit; 
  dlConfig.allowEdit = !disableEdit;


  dlConfig.addDropdownField({name: 'doctor_name',
    endpoint: '/hospital-portal/api/employees/byrole?role=Doctor,Nurse',
    valueField: 'employee_name',
    labelField: 'employee_name',
});

  dlConfig
    .addField({ name: 'log_id', label: 'Log ID', type: 'number', identifier: true, disabled: true })
    .addField({ name: 'doctor_name', label: 'Doctor/Nurse Name', type: 'dropdown', required: true })
    .addField({ name: 'admission_id', label: 'Admission ID', type: 'number', defaultValue: admissionId, visible: false })
    .addField({ name: 'log_date', label: 'Date', type: 'datetime-local', required: true,defaultValue: new Date().toISOString().slice(0, 16) })
    .addField({ name: 'notes', label: 'Note', type: 'textarea', required: true, maxRows: 5 });

  dlConfig
    .addColumn({ id: 'log_id', name: 'Log ID', selector: (row) => row.log_id, type: 'number', sortable: true,omit: true })
    .addColumn({ name: 'Date', selector: (row) => row.log_date, type: 'datetime', sortable: true })
    .addColumn({ name: 'Doctor/Nurse Name', selector: (row) => row.doctor_name, type: 'text', sortable: true })
    .addColumn({ name: 'Note', selector: (row) => <div style={{
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      hyphens: 'auto',
      lineHeight: '1.4',
      maxWidth: '700px',
      //set font size to 12px
      fontSize: '16px',
    }}
  ><p>
    {row.notes}
  </p>
  </div>, type: 'text',width: '400px' });

  return <DataList apiConfig={dlConfig} columns={dlConfig.columns} />;
};

export default DoctorLogs;
